import { groupAssociationChanged } from 'owa-calendar-cache';
import { initializeGroupCalendars } from '../utils/initializeGroupCalendars';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';
import debounce from 'lodash-es/debounce';
import { getUserMailboxInfo } from 'owa-client-ids';

let debouncedRefreshGroupCalendars = null;

// Respond to changes to group membership by refreshing the set of group calendars.
// When a group calendar is created or removed we get multiple row-modified notifications and they
// might be a couple of seconds apart, so we debounce to avoid hitting the server multiple times.
orchestrator(groupAssociationChanged, ({ payload: { id, EventType, Group } }) => {
    trace.info(`${id}: ${EventType}, ${Group?.SmtpAddress}`);
    // After the commit 5b669008 on Nov 9th, we are seeing a Reload event coming in here which is not expected.
    // When that happens, initializeGroupCalendars gets called 2nd time and the cache lands up in messed up state for group calendar, for reasons unknown
    // As a result, users see that group calendar events disappear within few seconds of boot and never come back.
    // Until we figure out the root cause of the issue, we are returning a no-op for the reload event here to fix user issue.
    // Bug 101931 for further investigation.
    if (EventType == 'Reload') {
        return;
    }
    if (!debouncedRefreshGroupCalendars) {
        debouncedRefreshGroupCalendars = debounce(
            initializeGroupCalendars.bind(null, getUserMailboxInfo().userIdentity, true),
            2000
        );
    }
    debouncedRefreshGroupCalendars();
});
